import * as S from "../Style/Page/Hat.style.js";
import { TbWorld } from "react-icons/tb";

const PageTitle = (props) => {
  const websiteLabel = props.website
    ? props.website.replace(/^https?:\/\//, "").replace(/\/$/, "")
    : "";

  // 기본은 준비완료(true)
  const isReady = props.isReady !== false;

  return (
    <S.PageTitle>
      <div className="page-title-left">
        <span className="title-bar"></span>

        <div className="title">
          <div className="kor">{props.titleko}</div>
          <div className="eng">{props.titleeng}</div>
        </div>
      </div>

      {(props.website || props.link) && (
        <div className="page-title-actions">

          {/* 홈페이지 버튼 */}
          {props.website &&
            (isReady ? (
              <a
                href={props.website}
                target="_blank"
                rel="noopener noreferrer"
                className="website-button"
              >
                <span className="website-icon">
                  <TbWorld />
                </span>

                <span className="website-text">
                  {websiteLabel}
                </span>
              </a>
            ) : (
              <div className="website-button disabled">
                <span className="website-icon">
                  <TbWorld />
                </span>

                <span className="website-text">
                  {websiteLabel}
                </span>
              </div>
            ))}

          {/* 준비중 */}
          {!isReady && (
            <span className="status-button">
              <span className="kor">준비중</span>
              <span className="eng">Coming Soon</span>
            </span>
          )}

          {/* 기존 바로가기 버튼 */}
          {props.link && (
            <a
              href={props.link}
              target="_blank"
              rel="noopener noreferrer"
              className="legacy-link-button"
            >
              <span className="kor">@ 바로가기</span>
              <span className="eng">@ Link</span>
            </a>
          )}

        </div>
      )}
    </S.PageTitle>
  );
};

export default PageTitle;